import State from 'interfaces/state/State';

export const paymentMethodIds$ = (state: State) => state.paymentMethod.ids;
export const isLoading$ = (state: State) => state.paymentMethod.isLoading;
export const isError$ = (state: State) => state.paymentMethod.isError;
